(() => {
  const reduceMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  window.ritamPrepareResultImages = async (container) => {
    if (!container) return;

    const images = [...container.querySelectorAll("img")];
    const primaryImages = [...container.querySelectorAll(".animated-block")]
      .map((item) => item.querySelector("img:not(.secondary-image)"))
      .filter(Boolean)
      .slice(0, 4);

    // Filtered results use their own reveal, so the theme's per-image spinner
    // and additional fade would only compete with the transition.
    images.forEach((image) => image.classList.add("no-lazy-loading"));

    primaryImages.forEach((image) => {
      image.loading = "eager";
      image.fetchPriority = "high";
    });

    const imageReady = primaryImages.map((image) => {
      if (image.complete && image.naturalWidth > 0) return Promise.resolve();

      if (typeof image.decode === "function") {
        return image.decode().catch(() => undefined);
      }

      return new Promise((resolve) => {
        image.addEventListener("load", resolve, { once: true });
        image.addEventListener("error", resolve, { once: true });
      });
    });

    await Promise.race([
      Promise.allSettled(imageReady),
      new Promise((resolve) => window.setTimeout(resolve, 650))
    ]);
  };

  window.ritamRevealResults = (container) => {
    if (!container) return;

    const items = [...container.querySelectorAll(".animated-block")];
    const targets = items.length > 0 ? items : [container.firstElementChild].filter(Boolean);
    const reduceMotion = reduceMotionQuery.matches;

    targets.forEach((target, index) => {
      if (typeof target.animate !== "function") return;

      target.getAnimations?.().forEach((animation) => animation.cancel());

      const keyframes = reduceMotion
        ? [{ opacity: 0.72 }, { opacity: 1 }]
        : [
            { opacity: 0.38, transform: "translate3d(0, 6px, 0)" },
            { opacity: 1, transform: "translate3d(0, 0, 0)" }
          ];

      target.animate(keyframes, {
        duration: reduceMotion ? 140 : 200,
        delay: reduceMotion ? 0 : Math.min(index * 24, 96),
        easing: "cubic-bezier(0.23, 1, 0.32, 1)",
        fill: "backwards"
      });
    });
  };
})();
